import { graphql } from "babel-plugin-relay/macro";
import { useLazyLoadQuery } from "react-relay";
import { PointPoolsScreen_PointsPoolsQuery } from "../../__generated__/PointPoolsScreen_PointsPoolsQuery.graphql";
import { PointPoolsTable } from "../components/points/pools/PointPoolsTable";
import { BaseScreen } from "./BaseScreen";
import { Permission } from "../../__generated__/MainNavigation_Query.graphql";
import { useSelector } from "react-redux";
import { selectHasPermissions } from "../redux/slices/CurrentUserSlice";

const QUERY = graphql`
	query PointPoolsScreen_PointsPoolsQuery {
		...PointPoolsTable_QueryFragment
	}
`;

export const PointPoolsScreen = () => {
	const data = useLazyLoadQuery<PointPoolsScreen_PointsPoolsQuery>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	const useCheckPermission = (permissions: Permission[]) =>
		useSelector((state: any) => selectHasPermissions(state, permissions));

	const isAdmin = useCheckPermission([
		"AccountPermission_System_Root",
		"UserInAccountPermission_System_Owner",
	]);

	if (!isAdmin) {
		return <div>Kein Zugriff</div>;
	}

	return (
		<BaseScreen>
			<h1>Punkte-Konten</h1>
			<PointPoolsTable queryFragmentRef={data} />
		</BaseScreen>
	);
};
